// Client-side portal API. Its own axios instance: the portal session is a
// separate cookie, and app sign-in handling (redirects, refresh) does not apply.
import axios from 'axios';

function baseUrl() {
  const { hostname, origin, protocol } = window.location;
  const local = hostname === 'localhost' || hostname === '127.0.0.1';
  if (!local) return `${origin}/api/portal`;
  if (process.env.REACT_APP_API_URL) return `${process.env.REACT_APP_API_URL}/portal`;
  return `${protocol}//${hostname}:5000/api/portal`;
}

const http = axios.create({ baseURL: baseUrl(), withCredentials: true });
let csrf = null;
const remember = (res) => { if (res.data && res.data.csrf) csrf = res.data.csrf; return res; };

const portalAPI = {
  login: (email, password, businessId, businessSlug) => http.post('/login', { email, password, business_id: businessId, business_slug: businessSlug }).then(remember),
  brand: (slug) => http.get(`/brand/${encodeURIComponent(slug)}`),
  acceptInvite: (token, password) => http.post('/accept-invite', { token, password }).then(remember),
  me: () => http.get('/me').then(remember),
  invoices: () => http.get('/invoices'),
  payments: () => http.get('/payments'),
  balance: () => http.get('/balance'),
  pay: (invoiceId) => http.post(`/invoices/${invoiceId}/pay`, {}, { headers: { 'X-Portal-CSRF': csrf || '' } }),
  autopay: () => http.get('/autopay'),
  autopaySetup: () => http.post('/autopay/setup', {}, { headers: { 'X-Portal-CSRF': csrf || '' } }),
  setAutopay: (enabled) => http.put('/autopay', { enabled }, { headers: { 'X-Portal-CSRF': csrf || '' } }),
  removeCard: () => http.delete('/autopay/card', { headers: { 'X-Portal-CSRF': csrf || '' } }),
  payoutAccount: () => http.get('/payout-account'),
  payoutOnboard: () => http.post('/payout-account/onboard', {}, { headers: { 'X-Portal-CSRF': csrf || '' } }),
  cashout: () => http.get('/cashout'),
  requestCashout: (body) => http.post('/cashout', body, { headers: { 'X-Portal-CSRF': csrf || '' } }),
  logout: () => http.post('/logout', null, { headers: { 'X-Portal-CSRF': csrf || '' } }),
};

export default portalAPI;
